import { Menu, MenuItemProps } from 'antd'
import { Link, PathMatch, useMatch, useResolvedPath, LinkProps } from 'react-router-dom'
import navMenuStyles from 'Styles/NavMenu.module.scss'
import { getNavMenuItemStyles } from 'Utils/getNavMenuStyles'

const defaultClasses = [navMenuStyles['menu-item']]
type LinkItemProps = {
  to: string
  linkProps?: Partial<LinkProps & React.RefAttributes<HTMLAnchorElement>>
  theme?: 'dark' | 'light'
  style?: React.CSSProperties
  /** Override if a link item should be active or not,
   *  by providing a callback
   */
  overrideMatch?: (match: PathMatch<string> | null) => Boolean | null
} & MenuItemProps

const LinkItem: React.FC<LinkItemProps> = ({
  children,
  to,
  linkProps,
  overrideMatch = null,
  theme,
  style = { marginLeft: '12px !important' },
  className,
  ...props
}) => {
  const resolved = useResolvedPath(to)
  let match: any = useMatch({ path: resolved.pathname, end: true })
  if (overrideMatch) {
    match = overrideMatch(match)
  }
  const classes = [...defaultClasses, className]
  if (match) classes.push(navMenuStyles['menu-item--selected'])

  return (
    <Menu.Item
      className={classes.join(' ')}
      {...props}
      style={{
        ...getNavMenuItemStyles(null, null, Boolean(match), theme),
        ...style,
      }}
    >
      <Link to={to} {...linkProps}>
        {children}
      </Link>
    </Menu.Item>
  )
}

export default LinkItem
